import api from "../api/axiosConfig";

export const resolverImagenUrl = (url) => {
  if (!url) return null;

  // Si ya es absoluta, devolverla
  if (url.startsWith("http")) return url;

  // Tomar baseURL del axios y quitar /api
  const base = api.defaults.baseURL.replace(/\/api$/, "");

  return `${base}${url}`;
};
